import {
  stringIsEmpty,
  stringsAreEqual,
  stringLengthLessThan,
} from 'utils/stringUtils';
import { PasswordFormValues, PasswordFormViolation } from 'types/state';
import { INPUT_PASSWORD_MIN_LENGTH } from 'utils/constants';

export const validatePasswordFormValues = (
  values: PasswordFormValues
): PasswordFormViolation[] => {
  const violations: PasswordFormViolation[] = [];

  const { password, passwordRepeat } = values;

  if (stringIsEmpty(password)) {
    violations.push({
      name: 'PasswordMissed',
    });
  }

  if (stringLengthLessThan(password, INPUT_PASSWORD_MIN_LENGTH)) {
    violations.push({
      name: 'PasswordTooShort',
    });
  }

  if (stringIsEmpty(passwordRepeat)) {
    violations.push({
      name: 'PasswordRepeatMissed',
    });
  }

  if (stringIsEmpty(passwordRepeat)) {
    violations.push({
      name: 'PasswordRepeatMissed',
    });
  }

  if (!stringsAreEqual(password, passwordRepeat)) {
    violations.push({
      name: 'PasswordsDidNotMatch',
    });
  }

  return violations;
};

export const isPasswordFormPasswordViolation = (
  violation: PasswordFormViolation
) => {
  switch (violation.name) {
    case 'PasswordMissed':
    case 'PasswordMatchedLogin':
    case 'PasswordTooShort':
      return true;
    default:
      return false;
  }
};

export const isPasswordFormPasswordRepeatViolation = (
  violation: PasswordFormViolation
) => {
  switch (violation.name) {
    case 'PasswordRepeatMissed':
    case 'PasswordsDidNotMatch':
      return true;
    default:
      return false;
  }
};
